module.exports = __webpack_public_path__ + "img/header-weddingRingsWhitegold.d134e7b.jpg";